import React from "react";
import Teen20 from "./resultModals/Teen20";
import TeenpattiOpen from "./resultModals/TeenpattiOpen";
import Teen9 from "./resultModals/Teen9";
import Teenpatti1Day from "./resultModals/Teenpatti1Day";
import SuperOver from "./resultModals/SuperOver";
import Race20 from "./resultModals/Race20";
import AB2 from "./resultModals/AndarBahar2";
import DragonTiger2020 from "./resultModals/2020DragonTiger";
import Baccarat from "./resultModals/Baccarat";
import Baccarat2 from "./resultModals/Baccarat2";
import Lucky7B from "./resultModals/Lucky7B";
import CasinoWar from "./resultModals/CasinoWar";
import Cmeter from "./resultModals/Cmeter";
import Card32 from "./resultModals/Card32";
import Card32B from "./resultModals/Card32B";
import Queen from "./resultModals/Queen";
import Dt1day from "./resultModals/Dt1day";
import Poker2020 from "./resultModals/Poker2020";
import InstantWorli from "./resultModals/InstantWorli";
import AAA from "./resultModals/AAA";
import BTable from "./resultModals/BTable";
import AndarBahar from "./resultModals/AndarBahar";
import Cricket20 from "./resultModals/Cricket20";
import Lucky7Aa from "./resultModals/Lucky7A";
import moment from "moment/moment";
import FiveCricket from "./resultModals/FiveCricket";
import Lottery from "./resultModals/Lottery";
import NoteNumber from "./resultModals/NoteNumber";
import JackTopOpenTeenpatti from "./resultModals/JackTopOPenTeenpatti";
import SicBo2 from "./resultModals/SicBo2";
import BallByBall from "./resultModals/BallByBall";
import RaceToSecond from "./resultModals/RaceToSecond";
import AAA2 from "./resultModals/AAA2";
import InstantTeenpatti from "./resultModals/InstantTeenpatti";
import InstantTeenPatti3 from "./resultModals/InstantTeenPatti3";

import OneCardOneDay from "./resultModals/OneCardOneDay";
import OneCard2020 from "./resultModals/OneCard2020";
import KonBanegaCrorepati from "./resultModals/KonBanegaCrorepati";

import TeenpattiB2020 from "./resultModals/TeenpattiB2020";
import RaceTo17 from "./resultModals/RaceTo17";
import MuflisTeenpatti from "./resultModals/MuflisTeenpatti";
import Baccarat29 from "./resultModals/Baccarat29";
import Cards2Teenpatti from "./resultModals/2CardsTeenpatti";
import Lucky7c from "./resultModals/Lucky7c";
import WorliMataka from "./resultModals/WorliMataka";
import Cards3Judgement from "./resultModals/3CardsJudgement";
import Poker6 from "./resultModals/Poker6";
import QueenTopOpenPatti from "./resultModals/QueenTopOpenPatti";
import Lucky15 from "./resultModals/Lucky15";
import Trap from "./resultModals/Trap";
import Trio from "./resultModals/Trio";
import InstantTeenPatti2 from "./resultModals/InstantTeenPatti2";
import SuperOver2 from "./resultModals/SuperOver2";
import SuperOver3 from "./resultModals/SuperOver3";
import AndarBahar50cards from "./resultModals/AndarBahar50cards";
import DTL2020 from "./resultModals/DTL2020";
import OneCardMeter from "./resultModals/OneCardMeter";
import DusKaDum from "./resultModals/DusKaDum";
import CricketMatch2020 from "./resultModals/CricketMatch2020";
import Teenpatti2 from "./resultModals/Teenpatti2";

const calculateTotalProfitLoss = (betResponseDTOList) => {
  return betResponseDTOList?.reduce(
    (sum, item) => sum + (item.profitLoss || 0),
    0
  );
};

export default function GenericIndividualResult({
  data,
  shortName,
  onClose,
  GAME_ID,
}) {
  console.log("shortName", shortName);
  console.log("GAME_ID", GAME_ID);
  const totalProfitLoss = calculateTotalProfitLoss(data?.betResponseDTOList);
  const renderResult = () => {
    switch (shortName || GAME_ID) {
      case "teen":
      case "teenpatti1day":
        return <Teenpatti1Day data={data} />;

      case "teen_20":
      case "teenpatti20":
        return <Teen20 data={data} />;

      case "teen_8":
      case "teenpattiopen":
        return <TeenpattiOpen data={data} />;

      case "teen_9":
      case "teenpattitest":
        return <Teen9 data={data} />;

      case "superover":
      case "super-over":
        return <SuperOver data={data} />;

      case "superover2":
      case "super-over2":
        return <SuperOver2 data={data} />;

      case "superover3":
      case "super-over3":
        return <SuperOver3 data={data} />;

      case "race20":
        return <Race20 data={data} />;

      case "abj":
      case "ab2":
        return <AB2 data={data} />;

      case "dt20":
      case "dragon_tiger_20":
      case "dragon_tiger_20_2":
        return <DragonTiger2020 data={data} />;

      case "baccarat":
        return <Baccarat data={data} />;

      case "baccarat2":
      case "baccarat baccarat2game":
        return <Baccarat2 data={data} />;

      case "casino-war":
      case "casino_war":
        return <CasinoWar data={data} />;

      case "cmeter":
      case "casino_meter":
        return <Cmeter data={data} />;

      case "card32eu":
      case "cards32a cards32b":
        return <Card32B data={data} />;

      case "card_32":
      case "cards32a":
        return <Card32 data={data} />;

      case "queen":
      case "casino_queen":
        return <Queen data={data} />;

      case "dragon_tiger_6":
      case "dt1day":
        return <Dt1day data={data} />;

      case "poker_20":
      case "poker20":
        return <Poker2020 data={data} />;

      case "cricket_v3":
      case "fiveCricket":
        return <FiveCricket data={data} />;

      case "poker_1_day":
      case "cards32a poker-20 Poker_oneday":
        return <Poker2020 data={data} />;

      case "worli2":
      case "worli":
        return <InstantWorli data={data} />;

      case "bollywood_table":
      case "bollywood":
        return <BTable data={data} />;

      case "aaa":
        return <AAA data={data} />;

      case "ab_20":
      case "ab ab3":
        return <AndarBahar data={data} />;

      case "ab3":
        return <AndarBahar50cards data={data} />;

      case "cricket_match_20":
      case "cricket20":
        return <Cricket20 data={data} />;

      case "lucky7":
      case "lucky7acards":
        return <Lucky7Aa data={data} />;

      case "lucky7eu":
      case "lucky7acards":
        return <Lucky7B data={data} />;

      case "lottcard":
        return <Lottery data={data} />;

      case "notenum":
        return <NoteNumber data={data} />;

      case "teen42":
        return <JackTopOpenTeenpatti data={data} />;

      case "sicbo2":
        return <SicBo2 data={data} />;

      case "ballbyball":
        return <BallByBall data={data} />;

      case "race2":
        return <RaceToSecond data={data} />;

      case "aaa2":
        return <AAA2 data={data} />;

      // case "teen3":
      //   return <InstantTeenpatti data={data} />;

      case "teen33":
        return <InstantTeenPatti3 data={data} />;

      case "teen32":
        return <InstantTeenPatti2 data={data} />;

      // case "teen1":
      //   return <OneCardOneDay data={data} />;

      // case "teen120":
      //   return <OneCard2020 data={data} />;

      // case "patti2":
      //   return <Cards2Teenpatti data={data} />;

      case "kbc":
        return <KonBanegaCrorepati data={data} />;

      case "trap":
        return <Trap data={data} />;

      case "teen20b":
        return <TeenpattiB2020 data={data} />;

      case "race17":
        return <RaceTo17 data={data} />;

      case "teenmuf":
        return <MuflisTeenpatti data={data} />;

      case "trio":
        return <Trio data={data} />;

      case "teensin":
        return <Baccarat29 data={data} />;

      case "patti2":
        return <Cards2Teenpatti data={data} />;

      case "cmeter1":
        return <OneCardMeter data={data} />;

      case "lucky7eu2":
        return <Lucky7c data={data} />;

      case "lucky15":
        return <Lucky15 data={data} />;

      case "worli":
        return <WorliMataka data={data} />;

      case "dtl20":
        return <DTL2020 data={data} />;

      case "teen120":
        return <OneCard2020 data={data} />;

      // case "teen20b":
      //   return <TeenpattiB2020 data={data} />;

      // case "race17":
      //   return <RaceTo17 data={data} />;

      case "teen3":
        return <InstantTeenpatti data={data} />;

      case "teen1":
        return <OneCardOneDay data={data} />;

      case "dum10":
        return <DusKaDum data={data} />;

      case "3cardj":
        return <Cards3Judgement data={data} />;

      case "poker6":
        return <Poker6 data={data} />;

         case "teen6":
        return <Teenpatti2 data={data} />;

      case "teen41":
        return <QueenTopOpenPatti data={data} />;

         case "cmatch20":
        return <CricketMatch2020 data={data} />;


      // case "lucky15":
      //   return <Lucky15 data={data} />;

      default:
        return renderDefaultResult();
    }
  };
  // if (GAME_ID === "LUCKY7") {
  //   return <Lucky7Aa data={data} />;
  // }

  const renderDefaultResult = () => {
    return (
      <div className="modal-body">
        <h1>Hello</h1>
      </div>
    );
  };

  const getModalTitle = () => {
    switch (shortName || GAME_ID) {
      case "teenpatti1day":
      case "teen":
        return "Teenpatti 1-day Result";

      case "teenpattiopen":
      case "teen_8":
        return "Teen Patti Open Result";

      case "teenpattitest":
      case "teen_9":
        return "Teen Patti Test Result";

      case "casino_war":
      case "casino-war":
        return "Casino War Result";

      case "teen3":
        return "Instant Teenpatti Result";

      case "super-over":
      case "superover":
        return "Super Over Result";

      case "race17":
        return "Race to 17 Result";

      case "cmeter1":
        return "One Card Meter Result";

      case "super-over2":
      case "superover2":
        return "Super Over 2 Result";

      case "super-over3":
      case "superover3":
        return "Super Over 3 Result";

      case "race20":
        return "Race 20 Result";

      case "ab2":
      case "abj":
        return "Andar Bahar 2 Result";

      case "dt20":
      case "dragon_tiger_20":
        return "Dragon Tiger 20-20 Result";

      case "dt1day":
      case "dragon_tiger_6":
        return "Dragon Tiger 1 Day Result";

      case "aaa2":
      case "aaa2":
        return "Amar Akabar Anthony 2 Result";

      case "baccarat":
        return "Baccarat Result";

      case "teen1":
        return "One Card One Day Result";

      case "dum10":
        return "Dus Ka Dum Result";

      case "baccarat2":
      case "baccarat baccarat2game":
        return "Baccarat 2 Result";

      // case "casino-war":
      // case "casino_war":
      //   return "Casino War";

      case "cmeter":
      case "casino_meter":
        return "Casino Meter Result";

      case "cards32a":
      case "card_32":
        return "Card 32 Result";

      case "teen20b":
        return "Teenpatti B 2020 Result";

      case "teen120":
        return "One Card 2020 Result";

      case "cards32a cards32b":
      case "card32eu":
        return "Card 32 B Result";

      case "queen":
      case "casino_queen":
        return "Casino Queen Result";

      case "aaa":
        return "Amar Akbar Anthony Result";

      case "bollywood":
      case "bollywood_table":
        return "Bollywood Casino Result";

      case "ab_20":
      case "ab ab3":
        return "Andar Bahar Result";

      case "cricket20":
      case "cricket_match_20":
        return "20-20 Cricket Result";

      case "cricket_v3":
      case "fiveCricket":
        return "Five Cricket Result";

      case "lucky7":
      case "lucky7acards":
        return "Lucky 7 - A Result";

      case "lucky7eu":
      case "lucky7acards":
        return "Lucky 7 - B Result";

      case "poker_1_day":
        return "Poker 1 Day Result";

      case "ab3":
        return "Andar Bahar 50 Cards Result";

      case "poker_20":
      case "poker20":
        return "Poker 20-20 Result";

      case "teen_20":
      case "teenpatti20":
        return "20-20 Teenpatti Result";

      case "worli":
      case "worli2":
        return "Instant Worli Result";

      case "dtl20":
        return "DTL2020 Result";

      case "trio":
        return "Trio Result";

      case "aaa2":
        return "Amar Akbar Anthony 2 Result";

      case "dtl20":
        return "DTL2020 Result";

      case "teen6":
        return "Teenpatti 2.0 Result";

      case "ab3":
        return "AndarBahar50cards Result";

      case "patti2":
        return "2 Cards Teenpatti Result";

      case "trap":
        return "The Trap Result";

      case "race2":
        return "Race to 2nd Result";

      case "notenum":
        return "Note Number Result";

      case "teenmuf":
        return "Muflis Teenpatti Result";

      case "teensin":
        return "Baccarat29 Result";

      case "lucky7eu2":
        return "Lucky 7 - C  Result";

      case "teen32":
        return "Instant TeenPatti 2.0 Result";

      case "ballbyball":
        return "Ball By Ball Result";

      case "teen33":
        return "Instant TeenPatti 3.0 Result";

      case "teen42":
        return "Jack Top Open Teenpatti Result";

      case "teen41":
        return "Queen Top Open Patti Result";

      case "lucky15":
        return "Lucky 15 Result";

      case "poker6":
        return "Poker 6 Players Result";

         case "cmatch20":
        return "Cricket Match 2020 Result";










      default:
        return "Game Result";
    }
  };
  // if (GAME_ID === "LUCKY7") {
  //   return "Lucky 7 - A";
  // }

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fade modal show"
      tabIndex={-1}
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title h4">{getModalTitle()}</div>
            <button
              onClick={onClose}
              type="button"
              className="btn-close"
              aria-label="Close"
            />
          </div>
          {renderResult()}
          <div className="row mt-4 justify-content-between">
            <div className="col-md-6">
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  id="all"
                  name="filter"
                  defaultValue="all"
                  defaultChecked=""
                />
                All
                <label className="form-check-label" htmlFor="all" />
              </div>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  id="back"
                  name="filter"
                  defaultValue="all"
                />
                Back
                <label className="form-check-label" htmlFor="back" />
              </div>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  id="lay"
                  name="filter"
                  defaultValue="all"
                />
                Lay
                <label className="form-check-label" htmlFor="lay" />
              </div>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  id="delete"
                  name="filter"
                  defaultValue="all"
                />
                Deleted
                <label className="form-check-label" htmlFor="delete" />
              </div>
            </div>
            <div className="col-md-6 text-end">
              <div>
                Total Bets:{" "}
                <span className="me-2">{data?.betResponseDTOList?.length}</span>
                Total Amount:
                <span
                  className={`me-2 ${totalProfitLoss > 0 ? "text-success" : "text-danger"
                    }`}
                >
                  {totalProfitLoss}
                </span>
              </div>
            </div>
          </div>
          <div className="mt-2 table-responsive">
            <table role="table" className="table table-bordered table-striped">
              <thead>
                <tr role="row">
                  <th colSpan={1} role="columnheader">
                    Nation
                  </th>
                  <th colSpan={1} role="columnheader" className="text-end">
                    Rate
                  </th>
                  <th colSpan={1} role="columnheader" className="text-end">
                    Amount
                  </th>
                  <th colSpan={1} role="columnheader" className="text-end">
                    Win
                  </th>
                  <th colSpan={1} role="columnheader">
                    Date
                  </th>
                  <th colSpan={1} role="columnheader">
                    Ip Address
                  </th>
                  <th colSpan={1} role="columnheader">
                    Browser Details
                  </th>
                  <th colSpan={1} role="columnheader">
                    <div className="text-end">
                      <div className="form-check form-check-inline">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          title="Toggle All Rows Selected"
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                {data?.betResponseDTOList?.map((item) => (
                  <tr role="row" className={item?.backRate ? "back" : "lay"}>
                    <td role="cell">{item?.runnerName}</td>
                    <td role="cell" className="text-end">
                      {item?.backRate ? item?.backRate : item?.layRate}
                    </td>
                    <td role="cell" className="text-end">
                      {item?.amount}
                    </td>
                    <td role="cell" className="text-end">
                      <span
                        role="cell"
                        className={
                          item?.profitLoss > 0 ? "text-success" : "text-danger"
                        }
                      >
                        {item?.profitLoss}
                      </span>
                    </td>
                    <td role="cell">
                      <span role="cell">
                        {moment(item?.createdDate + "Z").format(
                          "DD/MM/YYYY HH:mm:ss"
                        )}
                      </span>
                    </td>
                    <td role="cell">{item?.ip}</td>
                    <td role="cell">
                      <u title={item?.browserDetails || "No details available"}>
                        Details
                      </u>{" "}
                    </td>
                    <td role="cell">
                      <div className="text-end">
                        <div className="form-check form-check-inline" />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
